<template>
  <div class="right-mid-chart-right">
    <!-- right top chart title  -->
    <h6 class="chart-title">
      {{ $t('dashboard.titles.multipliers') }}{{ ' ' }}
      <span class="title-question-icon" @click.prevent="toggleHelp()">
        <iquestion />
      </span>
      <span
        class="settings-tab-text-icon multi-collapse collapse"
        :class="{ show: $store.state.layout.settingsOpened }"
        id="setting-overlay"
        style=""
      >
        <i class="fa fa-eye"></i>
      </span>
    </h6>

    <div
      class="chart-cover settings-tab"
      :class="{
        'no-content': noContent,
        'right-top-chart-table': noContent,
      }"
    >
      <p v-if="noContent">{{ $t('dashboard.multiples.noContent') }}</p>

      <!-- tab navs -->
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" v-for="item in availableMultipliers" :key="item">
          <a
            class="nav-link"
            :class="{
              active: mode === item,
              main: item.toUpperCase() === mainMult,
            }"
            data-toggle="tab"
            role="tab"
            :aria-selected="mode === item"
            @click.prevent="changeMode(item)"
            >{{ titles[item] }}</a
          >
        </li>
      </ul>

      <!-- tab content  -->
      <div v-if="!noContent" class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" role="tabpanel">
          <scale :comparable="scaleData[mode]" />
        </div>
      </div>

      <div
        class="settings-tab-overlay multi-collapse collapse"
        :class="{ show: $store.state.layout.settingsOpened }"
        id="setting-overlay"
        style=""
      ></div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import ColoredScale from './ColoredScale'
import iquestion from '@/components/icons/question'

export default {
  computed: {
    ...mapState('ticker', {
      scaleData: (state) => state.multipliers,
      mainMult: (state) => state.mainMult,
    }),
    availableMultipliers() {
      return _.keys(this.scaleData).reduce((arr, element) => {
        if (this.scaleData[element].length > 0) arr.push(element)
        return arr
      }, [])
    },
    noContent() {
      return this.availableMultipliers.length === 0
    },
  },
  data() {
    return {
      mode: 'pe',
      titles: {
        pe: 'P/E',
        evebitda: 'EV/EBITDA',
        pbv: 'P/BV',
      },
    }
  },
  watch: {
    scaleData() {
      this.mode = (this.mainMult ? this.mainMult : this.mode).toLowerCase()
    },
  },
  methods: {
    toggleHelp() {
      this.$store.commit('layout/updateModal', {
        modal: 'help',
        show: true,
        title: this.$t('modals.references.multipliers.title'),
        content: this.$t('modals.references.multipliers.content'),
        subtitle: this.$t('modals.messages.reference'),
      })
    },
    changeMode(mode) {
      this.mode = mode
    },
  },
  components: {
    scale: ColoredScale,
    iquestion: iquestion,
  },
}
</script>

<style></style>
